import Bugsnag from "@bugsnag/js";
import { loanApplicationService } from "@/modules/client/loan-application/store/services/loan-application-service";
import { setOrganization } from "@/modules/client/loan-application/store/reducers/organization-details-slice";

const getOrganizationDetails = loanApplicationService.injectEndpoints({
  endpoints: builder => ({
    getOrganizationDetails: builder.query({
      query: id => `organizations/${id}/loan-origination`,
      providesTags: (result, error, id) => [{ type: "BorrowerLoanOrigination", id }],
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setOrganization(data));
        } catch (err) {
          Bugsnag.notify(err);
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetOrganizationDetailsQuery } = getOrganizationDetails;

